import axios, { AxiosError } from "axios";
import configData from "../configData.json";

const client = axios.create({});
const location = window.location;

//Dev
let baseUrl: string = configData.ENDPOINT_BASE;

if (location !== null && location !== undefined) {
  if (location.hostname !== "localhost") {
    //prod
    baseUrl = configData.PROD_ENDPOINT_BASE;
  }
}

const GetTokenFromLocalStorage = (): any => {
  let userToken = localStorage.getItem("auth_token_hka");
  if (userToken) {
    return JSON.parse(userToken);
  }
  return null;
};

interface RequestProps {
  url: string;
  method: string;
  data: { querystringParams?: string; postData?: {} };
  successCallback?: Function;
  errorCallback?: Function;
  location?: string;
  AuthenticationRequired?: boolean;
  EncType?: string;
}

export async function Prerequisite(
  query: string,
  successCallback: any,
  errorCallback: any
) {
  if (query !== null && query !== undefined) {
    let config: any = {};
    let bearerobj = GetTokenFromLocalStorage();
    if (bearerobj !== null && bearerobj !== undefined) {
      config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ` + bearerobj.Token,
        },
      };
    } else {
      config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
    }

    //ajax
    //get with params
    await client
      .get(baseUrl + query, config)
      .then((response) => {
        if (successCallback !== null && successCallback !== undefined) {
          successCallback(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (errorCallback !== null && errorCallback !== undefined) {
          errorCallback(error);
        }
      });
  }
}

export async function MakeRequest(props: RequestProps): Promise<any> {
  if (props !== null && props !== undefined) {
    let config: any = {};
    let bearerobj = GetTokenFromLocalStorage();
    if (bearerobj !== null && bearerobj !== undefined) {
      config = {
        headers: {
          "Content-Type": props.EncType ?? "application/json",
          Authorization: `Bearer ` + bearerobj.Token,
        },
      };
    } else {
      config = {
        headers: {
          "Content-Type": props.EncType ?? "application/json",
        },
      };
    }

    const RequestType = async (props: RequestProps) => {
      switch (props.method) {
        case "get":
          if (
            props.data.querystringParams !== null &&
            props.data.querystringParams !== undefined
          ) {
            //get with params
            await client
              .get(baseUrl + props.url + props.data.querystringParams, config)
              .then((response) => {
                if (
                  props.successCallback !== null &&
                  props.successCallback !== undefined
                ) {
                  props.successCallback(response.data);
                } else {
                  return response.data;
                }
              })
              .catch((error: AxiosError) => {
                if (
                  props.errorCallback !== null &&
                  props.errorCallback !== undefined
                ) {
                  props.errorCallback(error);
                }
              });
          } else {
            //get without params
            await client
              .get(baseUrl + props.url, config)
              .then((response) => {
                if (
                  props.successCallback !== null &&
                  props.successCallback !== undefined
                ) {
                  props.successCallback(response.data);
                } else {
                  return response.data;
                }
              })
              .catch((error: AxiosError) => {
                if (
                  props.errorCallback !== null &&
                  props.errorCallback !== undefined
                ) {
                  props.errorCallback(error);
                }
              });
          }
          break;
        case "post":
          if (
            props.data.postData !== null &&
            props.data.postData !== undefined
          ) {
            //post
            await client
              .post(baseUrl + props.url, props.data.postData, config)
              .then((response) => {
                if (
                  props.successCallback !== null &&
                  props.successCallback !== undefined
                ) {
                  props.successCallback(response.data);
                } else {
                  return response.data;
                }
              })
              .catch((error: AxiosError) => {
                if (
                  props.errorCallback !== null &&
                  props.errorCallback !== undefined
                ) {
                  props.errorCallback(error);
                }
              });
          }
          break;
        case "put":
          if (
            props.data.postData !== null &&
            props.data.postData !== undefined
          ) {
            //put
            await client
              .put(baseUrl + props.url, props.data.postData, config)
              .then((response) => {
                if (
                  props.successCallback !== null &&
                  props.successCallback !== undefined
                ) {
                  props.successCallback(response.data);
                } else {
                  return response.data;
                }
              })
              .catch((error: AxiosError) => {
                if (
                  props.errorCallback !== null &&
                  props.errorCallback !== undefined
                ) {
                  props.errorCallback(error);
                }
              });
          }
          break;
        case "delete":
          if (
            props.data.querystringParams !== null &&
            props.data.querystringParams !== undefined
          ) {
            //delete
            await client
              .delete(
                baseUrl + props.url + "/" + props.data.querystringParams,
                config
              )
              .then((response) => {
                if (
                  props.successCallback !== null &&
                  props.successCallback !== undefined
                ) {
                  props.successCallback(response.data);
                } else {
                  return response.data;
                }
              })
              .catch((error: AxiosError) => {
                if (
                  props.errorCallback !== null &&
                  props.errorCallback !== undefined
                ) {
                  props.errorCallback(error);
                }
              });
          }
          break;
        default:
          //get without params
          await client
            .get(baseUrl + props.url, config)
            .then((response) => {
              if (
                props.successCallback !== null &&
                props.successCallback !== undefined
              ) {
                props.successCallback(response.data);
              } else {
                return response.data;
              }
            })
            .catch((error: AxiosError) => {
              if (
                props.errorCallback !== null &&
                props.errorCallback !== undefined
              ) {
                props.errorCallback(error);
              }
            });
      }
    };

    await RequestType(props);
  }
}

export async function RecaptchaRequest(
  uri: string,
  event: any,
  successCallback: any,
  errorCallback: any
): Promise<any> {
  let config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  //post
  await client
    .post(uri, event, config)
    .then((response) => {
      if (successCallback !== null && successCallback !== undefined) {
        successCallback(response.data);
      } else {
        return response.data;
      }
    })
    .catch((error: AxiosError) => {
      if (errorCallback !== null && errorCallback !== undefined) {
        errorCallback(error);
      }
    });
}
